function loadFormState() {
  return {
    bondId: localStorage.getItem("bondId"),
    bondToken: localStorage.getItem("bondToken"),
    bondIp: localStorage.getItem("bondIp"),
  };
}

function saveFormState({ bondId, bondToken, bondIp }) {
  localStorage.setItem("bondId", bondId);
  localStorage.setItem("bondToken", bondToken);
  localStorage.setItem("bondIp", bondIp);
}

function clearFormState() {
  localStorage.removeItem("bondId");
  localStorage.removeItem("bondToken");
  localStorage.removeItem("bondIp");
}

function loadDarkMode() {
  return localStorage.getItem("darkMode") === "true";
}

function saveDarkMode(darkMode) {
  return localStorage.setItem("darkMode", darkMode);
}

function loadIsOpen(path) {
  return localStorage.getItem(`e_${path}`) === "true";
}

function saveIsOpen(path, isOpen) {
  return localStorage.setItem(`e_${path}`, isOpen);
}

export default {
  loadFormState,
  saveFormState,
  clearFormState,
  loadDarkMode,
  saveDarkMode,
  loadIsOpen,
  saveIsOpen,
};
